module.exports = __webpack_public_path__ + "img/bg-desktop.1258939.jpg";